import {ApiClient} from './api'

export class AdyenHandleExpressPaymentService {
    baseUrl = '/api/adyen/handle-express-payment'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    async handlExpressPayment(data, basketId, customerId) {
        const res = await this.apiClient.post({
            body: JSON.stringify({
                data
            }),
            headers: {
                basketid: basketId,
                customerid: customerId
            }
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }
}
